<template>
  <div class="small">
    <!--  <chart-base v-if="datacollection" :chart-data="datacollection"></chart-base>
    <button @click="fillData()">Randomize</button> -->
    <!--  <horizontal-bar-graph-base :datacollection="datacollection2" :width="700" /> -->
    <MultiChartBase :chartData="datacollection2" :options="graphOpts" />
  </div>
</template>

<script>
import ChartBase from './LineChartData.js'
import HorizontalBarGraphBase from './HorizontalBarGraphBase.js'
import MultiChartBase from './MultiChartBase.js'

export default {
  components: {
    ChartBase,
    HorizontalBarGraphBase,
    MultiChartBase,
  },
  data() {
    return {
      datacollection: null,
    }
  },
  mounted() {},
  methods: {},
  computed: {
    graphOpts() {
      return {
        title: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'left',
              gridLines: {
                display: false,
              },
            },
            {
              id: 'B',
              type: 'linear',
              position: 'right',
              gridLines: {
                display: false,
              },
              ticks: {
                max: 1,
                min: 0,
              },
            },
          ],
        },
        legend: {
          display: true,
          labels: {
            font: {},
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
    datacollection2() {
      let datacollection = {
        // * labels that appear at left of graph
        labels: ['y', 'x', 'z', 'w'],
        datasets: [
          {
            fill: false,
            label: 'Test',
            data: [25.88, 30, 28, 40, 26],

            yAxisID: 'A',
          },
          {
            fill: false,
            label: 'Test2',
            data: [25.88, 26, 27, 20],
            type: 'bar',
            yAxisID: 'B',
          },
        ],
      }
      return datacollection
    },
  },
}
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>
